(function(){
(function(){
  function init(root){
    if(root.dataset.rkInit) return;
    root.dataset.rkInit='1';

    // reveal on scroll
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
      root.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
    } else {
      root.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});
    }

    // offer selector
    var stickyMeta=root.querySelector('.sticky__meta');
    var cards=root.querySelectorAll('.ocard');
    function pick(card){
      cards.forEach(function(c){c.classList.toggle('sel',c===card);});
      var r=card.querySelector('input[type=radio]'); if(r){r.checked=true;}
      if(stickyMeta&&card.getAttribute('data-sticky')){stickyMeta.textContent=card.getAttribute('data-sticky');}
    }
    cards.forEach(function(c){c.addEventListener('click',function(){pick(c);});});
    if(cards.length){pick(cards[0]);} // default to first plan (Try once)

    // hero buybox one-time / subscribe toggle
    var bbPrice=root.querySelector('.buybox__price');
    var opts=root.querySelectorAll('.opt label');
    opts.forEach(function(l){l.addEventListener('click',function(){
      opts.forEach(function(x){x.classList.remove('sel');});
      l.classList.add('sel');
      var pr=l.getAttribute('data-price')||'';
      var note=l.getAttribute('data-note')||'';
      if(bbPrice){bbPrice.innerHTML=pr+' <small>'+note+'</small>';}
    });});

    // sticky bar show after hero, hide near the end
    var sticky=root.querySelector('.sticky'),hero=root.querySelector('.hero'),end=root.querySelector('.end');
    function upd(){
      if(!sticky||!hero||!end) return;
      var past=hero.getBoundingClientRect().bottom<0;
      var atEnd=end.getBoundingClientRect().top<window.innerHeight*.7;
      sticky.classList.toggle('show',past&&!atEnd);
    }
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    upd();
  }
  function boot(){document.querySelectorAll('.rk-cult').forEach(init);}
  if(document.readyState!=='loading'){boot();} else {document.addEventListener('DOMContentLoaded',boot);}
  document.addEventListener('shopify:section:load',boot);
})();
})();
